// React
import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { ModalAlertPwd } from '../../containers/componentsInjection';
import { OrganizationsInjection } from '../../containers/organizationsInjection';

// View
import { OrganizationsFormPage } from './view';

// Helpers
import { APIClient } from '../../../../helpers/api_helper';
import '../../../../utils/validation/cpfMethodValidation';
import { notifyError } from '../../../../components/notify';

// styles

export const OrganizationsForm = () => {
  const [response, setResponse] = useState();
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [organizationsByHash, setOrganizationsByHash] = useState(null);
  const toggleAlert = () => setIsShowAlert(!isShowAlert);

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();

  const {
    createOrganizations,
    updateOrganizations,
    categoryOrganizations,
    getCategoryOrganizations,
  } = OrganizationsInjection();

  const getOrganizationsByHash = async (hash) => {
    const organizations = await api.get(`/register/organization/${hash}`);

    if (organizations) {
      setOrganizationsByHash(organizations);
      setIsActive(organizations.active === true ? true : false);
    }
  };

  const handleGenerateTemporaryPassword = async (hash) => {
    await api
      .get(`/register/organization/create-temp-password/${hash}`)
      .then((response) => {
        setResponse(response);
        toggleAlert();
      })
      .catch((error) => {
        notifyError(error.response.data.messages.error);
      });
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: organizationsByHash ? organizationsByHash.name : '',
      cnpjInput: organizationsByHash ? organizationsByHash.cnpj : '',
      categoryInput: organizationsByHash
        ? {
            value: organizationsByHash.organization_category_id,
            label: organizationsByHash.category_name,
          }
        : '',
      obsInput: organizationsByHash ? organizationsByHash.obs : '',
      emailInput: organizationsByHash ? organizationsByHash.email : '',
      phoneInput: organizationsByHash ? organizationsByHash.phone1 : '',
      siteInput: organizationsByHash ? organizationsByHash.site : '',
      emailRHInput: organizationsByHash ? organizationsByHash.email_hr : '',
      responsibleInput: organizationsByHash ? organizationsByHash.contact : '',
      telInput: organizationsByHash ? organizationsByHash.phone2 : '',
      whatsappInput: organizationsByHash ? organizationsByHash.whatsapp : '',
      zipInput: organizationsByHash ? organizationsByHash.zipcode : '',
      streetInput: organizationsByHash ? organizationsByHash.address1 : '',
      numberInput: organizationsByHash ? organizationsByHash.address_num : '',
      address2Input: organizationsByHash ? organizationsByHash.address2 : '',
      neighborhoodInput: organizationsByHash
        ? organizationsByHash.district
        : '',
      cityInput: organizationsByHash
        ? {
            value: organizationsByHash.city_id,
            label: organizationsByHash.city_name,
          }
        : '',
      isActiveSelect: organizationsByHash ? organizationsByHash.active : true,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      cnpjInput: Yup.string().cnpjType('Digite um CNPJ válido').nullable(),
      birthdayInput: Yup.date().nullable(),
      phoneInput: Yup.string().nullable(),
      zipInput: Yup.string().nullable(),
      streetInput: Yup.string().nullable(),
      numberInput: Yup.string().nullable(),
      neighborhoodInput: Yup.string().nullable(),
      cityInput: Yup.object().nullable(),
      siteInput: Yup.string().nullable(),
      emailRHInput: Yup.string().nullable(),
      responsibleInput: Yup.string().nullable(),
      categoryInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      obsInput: Yup.string().nullable(),
      emailInput: Yup.string().nullable(),
      telInput: Yup.string().nullable(),
      whatsappInput: Yup.string().nullable(),
      address2Input: Yup.string().nullable(),
      isActiveSelect: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        cnpj: values.cnpjInput || null,
        organization_category_id: values.categoryInput.value || null,
        email: values.emailInput || null,
        email_hr: values.emailRHInput || null,
        site: values.siteInput || null,
        contact: values.responsibleInput || null,
        address1: values.streetInput || null,
        address2: values.address2Input || null,
        address_num: values.numberInput || null,
        district: values.neighborhoodInput || null,
        city_id: values?.cityInput?.value || null,
        zipcode: values.zipInput || null,
        obs: values.obsInput || null,
        photo: values.photoImage || null,
        active: isActive,
        phone1: values.phoneInput || null,
        phone2: values.telInput || null,
        whatsapp: values.whatsappInput || null,
      };

      if (organizationsByHash) {
        updateOrganizations(organizationsByHash.id, valuesToSubmit, history);
      } else {
        createOrganizations(valuesToSubmit, history);
      }
    },
  });

  useEffect(() => {
    getCategoryOrganizations();
  }, []);

  useEffect(() => {
    if (id) {
      getOrganizationsByHash(id);
    }
  }, [id]);

  return (
    <>
      <OrganizationsFormPage
        // data
        id={id}
        organizationsByHash={organizationsByHash || []}
        categoryOrganizations={categoryOrganizations || []}
        // utils
        history={history}
        isActive={isActive}
        validation={validation}
        setIsActive={setIsActive}
        handleGenerateTemporaryPassword={handleGenerateTemporaryPassword}
      />

      <ModalAlertPwd
        isOpen={isShowAlert}
        toggle={toggleAlert}
        response={response || {}}
      />
    </>
  );
};
